import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../../store';

export type FeasibilityRating = 'High' | 'Medium' | 'Low' | '---';
export type FeasibilityFlow = 'old' | 'new';

export interface FeasibilityValue {
  label: string;
  rating: FeasibilityRating;
}

interface CurrentSolutionDetailsState {
  feasibilityValues: FeasibilityValue[];
  feasibility_percentage: number;
  feasibility_flow: FeasibilityFlow;
}

export interface CurrentFeasibilityDetails {
  feasibilityValues: FeasibilityValue[];
  feasibility_percentage: number;
  feasibility_flow: FeasibilityFlow;
}

const initialState: CurrentSolutionDetailsState = {
  feasibilityValues: [],
  feasibility_percentage: 0,
  feasibility_flow: 'old',
};

const currentSolutionDetailsSlice = createSlice({
  name: 'currentSolutionDetails',
  initialState,
  reducers: {
    setFeasibilityDetails: (
      state,
      action: PayloadAction<{
        feasibilityValues: FeasibilityValue[];
        feasibility_percentage: number;
        feasibility_flow: FeasibilityFlow;
      }>
    ) => {
      state.feasibilityValues = action.payload.feasibilityValues;
      state.feasibility_percentage = action.payload.feasibility_percentage;
      state.feasibility_flow = action.payload.feasibility_flow;
    },
    resetCurrentSolutionDetails: () => initialState,
  },
});

export const { setFeasibilityDetails, resetCurrentSolutionDetails } =
  currentSolutionDetailsSlice.actions;

export const selectFeasibilityValues = (state: RootState): FeasibilityValue[] =>
  state.currentSolutionDetails.feasibilityValues;
export const selectFeasibilityPercentage = (state: RootState): number =>
  state.currentSolutionDetails.feasibility_percentage;
export const selectFeasibilityFlow = (state: RootState): FeasibilityFlow =>
  state.currentSolutionDetails.feasibility_flow;
export const selectCurrentFeasibilityDetails = (state: RootState): CurrentFeasibilityDetails => ({
  feasibilityValues: state.currentSolutionDetails.feasibilityValues,
  feasibility_percentage: state.currentSolutionDetails.feasibility_percentage,
  feasibility_flow: state.currentSolutionDetails.feasibility_flow,
});

export default currentSolutionDetailsSlice.reducer;
